export default __webpack_public_path__ + "static/media/pcp-guide-chart-2.78c77ea0.svg";